import { useState } from "react";
import { Container, TextField, Button, List, ListItem, Checkbox, Typography } from "@mui/material";

export default function Home({tasks, setTasks}){
    const [input, setInput]=useState("");
    const addTask=() =>{
        if(!input.trim()) return;
        setTasks([...tasks, {text: input.trim(), done:false}]);
        console.log(tasks);
        setInput("")
    }
    const toggleTask=(index) =>{
        const updated=tasks.map((task, i) =>{
            if(i===index){
                return {...task, done: !task.done}
            } else {
                return task; 
            }
        });
        setTasks(updated);
    }

    const total=tasks.length;
    const completed=tasks.filter(task => task.done).length;

    return(
        <Container maxWidth="sm" sx={{mt:4}}>
            <Typography variant="h5" align="center">To-Do List</Typography>
            <Typography sx={{mb:4}} align="center">{completed} / {total} tehtud</Typography>
            <TextField fullWidth
              label="Uus Task" value={input} onChange={(e) => setInput(e.target.value)} sx={{mb:2}}></TextField>
            <Button fullWidth variant="contained" onClick={addTask} sx={{mb:3}}>Lisa</Button>
            <List>
                {tasks.map((task, index) =>(<ListItem key={index} onClick={() => toggleTask(index)}>
                    <Checkbox checked={task.done}>
                      
                    </Checkbox>  <Typography sx={{textDecoration: task.done?"line-through":"none",
                            color: task.done?"gray":"black"
                        }}
                       >{task.text}</Typography>
                </ListItem>))}
            </List>
        </Container>
    )
}